import React, { Component } from 'react';
import {
  Container,
  Row,
  Col
} from "reactstrap";

const ContentWrapper = ({children, colspan}) => {

  return (
      <>
        <section className="section">
           <Container style={{minHeight:'500px'}}>
              <Row>
                <Col></Col>
                <Col xs={colspan}>
                   {children}
                </Col>
              <Col></Col>
              </Row>
            </Container>
         </section>
      </>
  )
}

export default ContentWrapper;
